import { render, staticRenderFns } from "./static.vue?vue&type=template&id=d480ddce&scoped=true&"
import script from "./static.vue?vue&type=script&lang=js&"
export * from "./static.vue?vue&type=script&lang=js&"
import style0 from "./static.vue?vue&type=style&index=0&id=d480ddce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480ddce",
  null
  
)

export default component.exports